import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"
import Step from "@fae/source/models/Step.js"

export default function CarryOn(stage) {
    if(stage == undefined) console.log("why no stage??")
    const step = App.sequence.steps.shift()
    if(step.followingProtosteps == undefined) {
        // console.log("no following protosteps")
        return
    } else {
        // console.log("YES!!! WE HAVE FOLLOWING PROTOSTEPS!!", step.followingProtosteps)
    }
    if(step.followingProtosteps.length == 0) {
        step.followingProtosteps = [Step.instantiate({"alphastage": stage})]
    }
    App.sequence = {
        "steps": Stage.processEventSteps(Stage.copy(stage), step.followingProtosteps)
    }
    // console.log(step.followingProtosteps)
    if(App?.game?.chapter?.stage != undefined
    && App.sequence.steps != undefined
    && App.sequence.steps.length > 0
    && App.sequence.steps[App.sequence.steps?.length - 1]?.omegastage != undefined) {
        App.game.chapter.stage = App.sequence.steps[App.sequence.steps.length - 1].omegastage
    }
}
